import { styled as r, Button as l } from "@mui/material";
import { noForwardProps as d } from "../../temp-lib/util/styled/index.js";
import m from "./ApeironTooltip.js";
import { jsxs as c, Fragment as u, jsx as i } from "react/jsx-runtime";
const x = r(l)`
  all: unset;
  position: relative;
  cursor: pointer;
`, h = r(m, d)`
  font-size: 12px !important;
  max-width: ${(t) => t.__maxWidth || "unset"};
`, B = (t) => {
  const {
    children: n,
    className: e,
    maxWidth: p,
    stay: s,
    tooltip: a,
    tooltipId: o
  } = t;
  return /* @__PURE__ */ c(u, {
    children: [/* @__PURE__ */ i(x, {
      className: e,
      "data-tooltip-id": o,
      children: n
    }), /* @__PURE__ */ i(h, {
      id: o,
      stay: s,
      __maxWidth: p,
      children: a
    })]
  });
};
export {
  B as default
};
//# sourceMappingURL=ApeironTooltipSection.js.map
